module.exports = __webpack_public_path__ + "img/hc_pro_night_9.9528add1.jpg";